import { useState, useMemo } from 'react'
import {Search, X, Copy, MessageCircleDashed as MessageCircle, Calculator} from 'lucide-react'
import toast from 'react-hot-toast'
import { copiarTexto } from '@/utils/clipboard'

interface Produto {
  nome: string
  tamanho: string
  preco: number
  pv: number
  categoria: string
}

// Categorias oficiais (Brasil)
const CAT_1 = 'Óleos Essenciais Individuais 5ml e 15ml'
const CAT_2 = 'Aromas Naturais — Suplementos e Alimentos'
const CAT_3 = 'Óleos Essenciais e Mix Roll-On 5 e 10ml'
const CAT_4 = 'Mix de Óleos Essenciais'
const CAT_5 = 'dōTERRA Emotional Aromatherapy®'
const CAT_6 = 'Cuidados Pessoais'
const CAT_7 = 'Kits e Acessórios'

// Tabela completa de produtos — preços de membro (Brasil)
const PRODUTOS: Produto[] = [
  // ═══════ CATEGORIA 1 — ÓLEOS ESSENCIAIS INDIVIDUAIS 5ml e 15ml ═══════
  { nome: 'Basil - Manjericão', tamanho: '15ml', preco: 230.00, pv: 27, categoria: CAT_1 },
  { nome: 'Bergamot - Bergamota', tamanho: '15ml', preco: 232.50, pv: 31, categoria: CAT_1 },
  { nome: 'Black Pepper - Pimenta-preta', tamanho: '5ml', preco: 187.50, pv: 24, categoria: CAT_1 },
  { nome: 'Black Spruce - Abeto-negro', tamanho: '5ml', preco: 135.00, pv: 18, categoria: CAT_1 },
  { nome: 'Breu Branco', tamanho: '5ml', preco: 243.75, pv: 32, categoria: CAT_1 },
  { nome: 'Cassia - Canela-cássia', tamanho: '15ml', preco: 150.00, pv: 20, categoria: CAT_1 },
  { nome: 'Cedarwood - Cedro', tamanho: '15ml', preco: 105.00, pv: 14, categoria: CAT_1 },
  { nome: 'Cilantro - Coentro', tamanho: '15ml', preco: 217.50, pv: 29, categoria: CAT_1 },
  { nome: 'Citronella - Citronela', tamanho: '15ml', preco: 92.50, pv: 12, categoria: CAT_1 },
  { nome: 'Clary Sage - Sálvia-esclareia', tamanho: '15ml', preco: 307.50, pv: 41, categoria: CAT_1 },
  { nome: 'Clove - Cravo', tamanho: '15ml', preco: 121.25, pv: 16, categoria: CAT_1 },
  { nome: 'Copaiba - Copaíba', tamanho: '15ml', preco: 240.00, pv: 40, categoria: CAT_1 },
  { nome: 'Coriander - Coentro', tamanho: '15ml', preco: 172.50, pv: 23, categoria: CAT_1 },
  { nome: 'Cypress - Cipreste', tamanho: '15ml', preco: 135.00, pv: 18, categoria: CAT_1 },
  { nome: 'Douglas Fir - Abeto de Douglas', tamanho: '5ml', preco: 167.50, pv: 22, categoria: CAT_1 },
  { nome: 'Erva Baleeira', tamanho: '5ml', preco: 223.75, pv: 31, categoria: CAT_1 },
  { nome: 'Fennel (Sweet) - Erva-doce', tamanho: '15ml', preco: 105.00, pv: 14, categoria: CAT_1 },
  { nome: 'Frankincense - Olíbano', tamanho: '15ml', preco: 486.25, pv: 64, categoria: CAT_1 },
  { nome: 'Geranium - Gerânio', tamanho: '15ml', preco: 238.75, pv: 31, categoria: CAT_1 },
  { nome: 'Ginger - Gengibre', tamanho: '15ml', preco: 268.75, pv: 33, categoria: CAT_1 },
  { nome: 'Grapefruit - Toranja', tamanho: '15ml', preco: 140.00, pv: 17, categoria: CAT_1 },
  { nome: 'Green Mandarin - Mandarina-verde', tamanho: '15ml', preco: 210.00, pv: 28, categoria: CAT_1 },
  { nome: 'Guaiacwood', tamanho: '15ml', preco: 127.50, pv: 16, categoria: CAT_1 },
  { nome: 'Hawaiian Sandalwood - Sândalo-havaiano', tamanho: '5ml', preco: 524.00, pv: 60, categoria: CAT_1 },
  { nome: 'Helichrysum - Sempre-viva', tamanho: '5ml', preco: 573.00, pv: 65, categoria: CAT_1 },
  { nome: 'Lavender - Lavanda', tamanho: '15ml', preco: 148.00, pv: 23, categoria: CAT_1 },
  { nome: 'Lemon - Limão-siciliano', tamanho: '15ml', preco: 86.25, pv: 11, categoria: CAT_1 },
  { nome: 'Lemon Eucalyptus - Eucalipto-limão', tamanho: '15ml', preco: 90.00, pv: 12, categoria: CAT_1 },
  { nome: 'Lemongrass - Capim-limão', tamanho: '15ml', preco: 82.50, pv: 11, categoria: CAT_1 },
  { nome: 'Lime - Limão', tamanho: '15ml', preco: 107.50, pv: 14, categoria: CAT_1 },
  { nome: 'Madagascar Vanilla', tamanho: '5ml', preco: 258.75, pv: 34, categoria: CAT_1 },
  { nome: 'Mâlama', tamanho: '15ml', preco: 181.25, pv: 23, categoria: CAT_1 },
  { nome: 'Marjoram - Manjerona', tamanho: '15ml', preco: 160.00, pv: 20, categoria: CAT_1 },
  { nome: 'Melaleuca - Tea Tree', tamanho: '15ml', preco: 157.50, pv: 21, categoria: CAT_1 },
  { nome: 'Melissa', tamanho: '5ml', preco: 671.00, pv: 76, categoria: CAT_1 },
  { nome: 'Myrrh - Mirra', tamanho: '15ml', preco: 491.25, pv: 51, categoria: CAT_1 },
  { nome: 'Oregano - Orégano', tamanho: '15ml', preco: 172.50, pv: 23, categoria: CAT_1 },
  { nome: 'Patchouli', tamanho: '15ml', preco: 220.00, pv: 29, categoria: CAT_1 },
  { nome: 'Peppermint - Hortelã-pimenta', tamanho: '15ml', preco: 138.00, pv: 23, categoria: CAT_1 },
  { nome: 'Petitgrain', tamanho: '15ml', preco: 172.50, pv: 23, categoria: CAT_1 },
  { nome: 'Roman Chamomile - Camomila-romana', tamanho: '5ml', preco: 382.50, pv: 51, categoria: CAT_1 },
  { nome: 'Rosemary - Alecrim', tamanho: '15ml', preco: 123.75, pv: 16, categoria: CAT_1 },
  { nome: 'Siberian Fir - Pinheiro-siberiano', tamanho: '15ml', preco: 142.50, pv: 19, categoria: CAT_1 },
  { nome: 'Spearmint - Hortelã-verde', tamanho: '15ml', preco: 217.50, pv: 29, categoria: CAT_1 },
  { nome: 'Spikenard - Nardo', tamanho: '5ml', preco: 420.00, pv: 56, categoria: CAT_1 },
  { nome: 'Tangerine - Tangerina', tamanho: '15ml', preco: 127.50, pv: 16, categoria: CAT_1 },
  { nome: 'Thyme - Tomilho', tamanho: '15ml', preco: 218.75, pv: 28, categoria: CAT_1 },
  { nome: 'Vetiver', tamanho: '15ml', preco: 383.75, pv: 41, categoria: CAT_1 },
  { nome: 'Wild Orange - Laranja-selvagem', tamanho: '15ml', preco: 90.00, pv: 12, categoria: CAT_1 },
  { nome: 'Wintergreen', tamanho: '15ml', preco: 135.00, pv: 18, categoria: CAT_1 },
  { nome: 'Ylang Ylang', tamanho: '5ml', preco: 92.00, pv: 12, categoria: CAT_1 },
  { nome: 'Ylang Ylang', tamanho: '15ml', preco: 280.00, pv: 37, categoria: CAT_1 },

  // ═══════ CATEGORIA 2 — AROMAS NATURAIS, SUPLEMENTOS E ALIMENTOS ═══════
  { nome: 'Adaptiv® Pastilhas', tamanho: '60 pastilhas', preco: 231.25, pv: 31, categoria: CAT_2 },
  { nome: 'Basil - Manjericão (Ingestão)', tamanho: '5ml', preco: 77.50, pv: 9, categoria: CAT_2 },
  { nome: 'dōTERRA Beauty Power™ Collagen Elixir', tamanho: '210g', preco: 198.00, pv: 35, categoria: CAT_2 },
  { nome: 'Bergamot - Bergamota (Ingestão)', tamanho: '5ml', preco: 92.50, pv: 12, categoria: CAT_2 },
  { nome: 'Black Pepper - Pimenta-preta (Ingestão)', tamanho: '5ml', preco: 187.50, pv: 24, categoria: CAT_2 },
  { nome: 'Cardamom - Cardamomo (Ingestão)', tamanho: '5ml', preco: 203.75, pv: 29, categoria: CAT_2 },
  { nome: 'Cassia - Canela-cássia (Ingestão)', tamanho: '5ml', preco: 60.00, pv: 8, categoria: CAT_2 },
  { nome: 'Cilantro - Coentro (Ingestão)', tamanho: '5ml', preco: 70.00, pv: 9, categoria: CAT_2 },
  { nome: 'Cinnamon Bark', tamanho: '5ml', preco: 188.75, pv: 24, categoria: CAT_2 },
  { nome: 'Clary Sage - Sálvia-esclareia (Ingestão)', tamanho: '5ml', preco: 122.50, pv: 17, categoria: CAT_2 },
  { nome: 'Clove - Cravo (Ingestão)', tamanho: '5ml', preco: 54.50, pv: 7, categoria: CAT_2 },
  { nome: 'Copaiba - Copaíba (Ingestão)', tamanho: '5ml', preco: 120.00, pv: 16, categoria: CAT_2 },
  { nome: 'Copaiba Softgels', tamanho: '60 pastilhas', preco: 189.00, pv: 28, categoria: CAT_2 },
  { nome: 'Coriander - Coentro (Ingestão)', tamanho: '5ml', preco: 65.00, pv: 9, categoria: CAT_2 },
  { nome: 'DDR Prime® Pastilha', tamanho: '90 pastilhas', preco: 243.75, pv: 35, categoria: CAT_2 },
  { nome: 'dōTERRA Creatina Lifepower', tamanho: '105g', preco: 179.00, pv: 27, categoria: CAT_2 },
  { nome: 'Fennel (Sweet) - Erva-doce (Ingestão)', tamanho: '5ml', preco: 47.50, pv: 6, categoria: CAT_2 },
  { nome: 'Frankincense - Olíbano (Ingestão)', tamanho: '5ml', preco: 202.50, pv: 27, categoria: CAT_2 },
  { nome: 'Geranium - Gerânio (Ingestão)', tamanho: '5ml', preco: 93.75, pv: 12, categoria: CAT_2 },
  { nome: 'Ginger - Gengibre (Ingestão)', tamanho: '5ml', preco: 96.25, pv: 11, categoria: CAT_2 },
  { nome: 'Grapefruit - Toranja (Ingestão)', tamanho: '5ml', preco: 55.00, pv: 6, categoria: CAT_2 },
  { nome: 'Green Mandarin - Mandarina-verde (Ingestão)', tamanho: '5ml', preco: 73.75, pv: 10, categoria: CAT_2 },
  { nome: 'Juniper Berry - Zimbro (Ingestão)', tamanho: '5ml', preco: 157.50, pv: 21, categoria: CAT_2 },
  { nome: 'Lavender - Lavanda (Ingestão)', tamanho: '5ml', preco: 77.50, pv: 10, categoria: CAT_2 },
  { nome: 'Lemon - Limão-siciliano (Ingestão)', tamanho: '5ml', preco: 36.25, pv: 4, categoria: CAT_2 },
  { nome: 'Lemongrass - Capim-limão (Ingestão)', tamanho: '5ml', preco: 32.50, pv: 4, categoria: CAT_2 },
  { nome: 'dōTERRA Lifeshot', tamanho: '1 litro', preco: 156.00, pv: 24, categoria: CAT_2 },
  { nome: 'dōTERRA Lifeshot Pack com 2', tamanho: '2 litros', preco: 315.00, pv: 52, categoria: CAT_2 },
  { nome: 'Lime - Limão (Ingestão)', tamanho: '5ml', preco: 43.75, pv: 5, categoria: CAT_2 },
  { nome: 'Marjoram - Manjerona (Ingestão)', tamanho: '5ml', preco: 65.00, pv: 8, categoria: CAT_2 },
  { nome: 'MetaPWR™ Aroma Natural de Especiarias', tamanho: '15ml', preco: 223.75, pv: 27, categoria: CAT_2 },
  { nome: 'MetaPWR™ Pastilhas', tamanho: '90 pastilhas', preco: 236.25, pv: 28, categoria: CAT_2 },
  { nome: 'Myrrh - Mirra (Ingestão)', tamanho: '5ml', preco: 186.25, pv: 19, categoria: CAT_2 },
  { nome: 'On Guard® (Ingestão)', tamanho: '5ml', preco: 105.00, pv: 14, categoria: CAT_2 },
  { nome: 'On Guard® Beadlets', tamanho: '125 pastilhas', preco: 116.25, pv: 15, categoria: CAT_2 },
  { nome: 'On Guard® Pastilhas', tamanho: '60 pastilhas', preco: 186.25, pv: 22, categoria: CAT_2 },
  { nome: 'Oregano - Orégano (Ingestão)', tamanho: '5ml', preco: 75.00, pv: 10, categoria: CAT_2 },
  { nome: 'Patchouli (Ingestão)', tamanho: '5ml', preco: 85.00, pv: 11, categoria: CAT_2 },
  { nome: 'Peppermint - Hortelã-pimenta (Ingestão)', tamanho: '5ml', preco: 68.75, pv: 9, categoria: CAT_2 },
  { nome: 'Peppermint Beadlets', tamanho: '125 pastilhas', preco: 105.00, pv: 12, categoria: CAT_2 },
  { nome: 'Petitgrain (Ingestão)', tamanho: '5ml', preco: 68.75, pv: 9, categoria: CAT_2 },
  { nome: 'Pink Pepper - Pimenta-rosa (Ingestão)', tamanho: '5ml', preco: 172.50, pv: 20, categoria: CAT_2 },
  { nome: 'Rosemary - Alecrim (Ingestão)', tamanho: '5ml', preco: 50.00, pv: 6, categoria: CAT_2 },
  { nome: 'Siberian Fir (Ingestão)', tamanho: '5ml', preco: 52.50, pv: 7, categoria: CAT_2 },
  { nome: 'Spearmint (Ingestão)', tamanho: '5ml', preco: 73.75, pv: 10, categoria: CAT_2 },
  { nome: 'Tangerine - Tangerina (Ingestão)', tamanho: '5ml', preco: 52.50, pv: 7, categoria: CAT_2 },
  { nome: 'Thyme - Tomilho (Ingestão)', tamanho: '5ml', preco: 92.50, pv: 11, categoria: CAT_2 },
  { nome: 'Turmeric - Cúrcuma (Ingestão)', tamanho: '15ml', preco: 218.75, pv: 28, categoria: CAT_2 },
  { nome: 'Turmeric Pastilhas', tamanho: '60 pastilhas', preco: 186.25, pv: 24, categoria: CAT_2 },
  { nome: 'Vetiver (Ingestão)', tamanho: '5ml', preco: 162.50, pv: 18, categoria: CAT_2 },
  { nome: 'VM Complex', tamanho: '120 cápsulas', preco: 186.00, pv: 28, categoria: CAT_2 },
  { nome: 'Wild Orange - Laranja-selvagem (Ingestão)', tamanho: '5ml', preco: 32.50, pv: 4, categoria: CAT_2 },
  { nome: 'Zendocrine® (Ingestão)', tamanho: '5ml', preco: 73.75, pv: 9, categoria: CAT_2 },
  { nome: 'Zendocrine® Pastilhas', tamanho: '60 pastilhas', preco: 168.00, pv: 21, categoria: CAT_2 },
  { nome: 'ZenGest® (Ingestão)', tamanho: '5ml', preco: 105.00, pv: 11, categoria: CAT_2 },
  { nome: 'ZenGest® Pastilhas', tamanho: '60 pastilhas', preco: 161.25, pv: 20, categoria: CAT_2 },

  // ═══════ CATEGORIA 3 — ÓLEOS ESSENCIAIS E MIX ROLL-ON 5 e 10ml ═══════
  { nome: 'Adaptiv® Touch', tamanho: '10ml', preco: 150.00, pv: 20, categoria: CAT_3 },
  { nome: 'dōTERRA Brave®', tamanho: '10ml', preco: 165.00, pv: 22, categoria: CAT_3 },
  { nome: 'dōTERRA Breathe® Touch', tamanho: '10ml', preco: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Calmer®', tamanho: '10ml', preco: 150.00, pv: 20, categoria: CAT_3 },
  { nome: 'Clarycalm®', tamanho: '10ml', preco: 218.75, pv: 28, categoria: CAT_3 },
  { nome: 'Copaiba Touch', tamanho: '10ml', preco: 172.50, pv: 23, categoria: CAT_3 },
  { nome: 'dōTERRA Deep Blue® Touch', tamanho: '10ml', preco: 322.50, pv: 42, categoria: CAT_3 },
  { nome: 'dōTERRA Frankincense Touch', tamanho: '10ml', preco: 375.00, pv: 50, categoria: CAT_3 },
  { nome: 'Helichrysum Touch', tamanho: '10ml', preco: 398.50, pv: 50, categoria: CAT_3 },
  { nome: 'Hope™ Touch', tamanho: '10ml', preco: 156.25, pv: 20, categoria: CAT_3 },
  { nome: 'inTune®', tamanho: '10ml', preco: 253.00, pv: 32, categoria: CAT_3 },
  { nome: 'Jasmine Touch', tamanho: '10ml', preco: 295.00, pv: 39, categoria: CAT_3 },
  { nome: 'Lavender Touch', tamanho: '10ml', preco: 120.00, pv: 16, categoria: CAT_3 },
  { nome: 'Melaleuca Touch', tamanho: '10ml', preco: 105.00, pv: 14, categoria: CAT_3 },
  { nome: 'On Guard® Touch', tamanho: '10ml', preco: 180.00, pv: 24, categoria: CAT_3 },
  { nome: 'Oregano Touch', tamanho: '10ml', preco: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'PastTense®', tamanho: '10ml', preco: 150.00, pv: 20, categoria: CAT_3 },
  { nome: 'Peppermint Touch', tamanho: '10ml', preco: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Rescuer®', tamanho: '10ml', preco: 120.00, pv: 16, categoria: CAT_3 },
  { nome: 'Rose Touch', tamanho: '10ml', preco: 487.50, pv: 65, categoria: CAT_3 },
  { nome: 'dōTERRA Steady®', tamanho: '10ml', preco: 120.00, pv: 16, categoria: CAT_3 },
  { nome: 'dōTERRA Stronger®', tamanho: '10ml', preco: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Tamer®', tamanho: '10ml', preco: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'dōTERRA Thinker®', tamanho: '10ml', preco: 127.50, pv: 17, categoria: CAT_3 },
  { nome: 'Vetiver Touch', tamanho: '10ml', preco: 247.50, pv: 33, categoria: CAT_3 },
  { nome: 'Whisper™ Touch', tamanho: '5ml', preco: 112.50, pv: 15, categoria: CAT_3 },
  { nome: 'ZenGest® Touch', tamanho: '10ml', preco: 172.50, pv: 23, categoria: CAT_3 },

  // ═══════ CATEGORIA 4 — MIX DE ÓLEOS ESSENCIAIS ═══════
  { nome: 'Adaptiv®', tamanho: '15ml', preco: 283.75, pv: 37, categoria: CAT_4 },
  { nome: 'Air-X™', tamanho: '15ml', preco: 173.75, pv: 23, categoria: CAT_4 },
  { nome: 'dōTERRA AromaTouch®', tamanho: '15ml', preco: 218.75, pv: 29, categoria: CAT_4 },
  { nome: 'dōTERRA Balance®', tamanho: '15ml', preco: 157.50, pv: 21, categoria: CAT_4 },
  { nome: 'dōTERRA Breathe®', tamanho: '15ml', preco: 172.50, pv: 23, categoria: CAT_4 },
  { nome: 'Citrus Bliss®', tamanho: '15ml', preco: 135.00, pv: 17, categoria: CAT_4 },
  { nome: 'DDR Prime®', tamanho: '15ml', preco: 225.00, pv: 29, categoria: CAT_4 },
  { nome: 'dōTERRA Deep Blue®', tamanho: '5ml', preco: 216.00, pv: 36, categoria: CAT_4 },
  { nome: 'dōTERRA Serenity®', tamanho: '15ml', preco: 255.00, pv: 34, categoria: CAT_4 },
  { nome: 'dōTERRA Elevation®', tamanho: '15ml', preco: 348.50, pv: 42, categoria: CAT_4 },
  { nome: 'Eucalyptus (Blend)', tamanho: '15ml', preco: 143.75, pv: 19, categoria: CAT_4 },
  { nome: 'Forest Bathing', tamanho: '15ml', preco: 236.25, pv: 28, categoria: CAT_4 },
  { nome: 'dōTERRA Hygge™', tamanho: '15ml', preco: 262.50, pv: 33, categoria: CAT_4 },
  { nome: 'On Guard®', tamanho: '15ml', preco: 270.00, pv: 36, categoria: CAT_4 },
  { nome: 'dōTERRA Purify®', tamanho: '15ml', preco: 150.00, pv: 20, categoria: CAT_4 },
  { nome: 'Sunny Citrus', tamanho: '15ml', preco: 142.50, pv: 16, categoria: CAT_4 },
  { nome: 'Supermint', tamanho: '15ml', preco: 181.25, pv: 25, categoria: CAT_4 },
  { nome: 'TerraShield®', tamanho: '15ml', preco: 82.50, pv: 11, categoria: CAT_4 },
  { nome: 'Zendocrine®', tamanho: '15ml', preco: 185.00, pv: 24, categoria: CAT_4 },
  { nome: 'ZenGest®', tamanho: '15ml', preco: 265.00, pv: 35, categoria: CAT_4 },

  // ═══════ CATEGORIA 5 — dōTERRA EMOTIONAL AROMATHERAPY® ═══════
  { nome: 'dōTERRA Cheer®', tamanho: '5ml', preco: 195.00, pv: 26, categoria: CAT_5 },
  { nome: 'dōTERRA Cheer® Touch Roll-On', tamanho: '10ml', preco: 120.00, pv: 16, categoria: CAT_5 },
  { nome: 'dōTERRA Console®', tamanho: '5ml', preco: 285.00, pv: 38, categoria: CAT_5 },
  { nome: 'dōTERRA Console® Touch Roll-On', tamanho: '10ml', preco: 180.00, pv: 24, categoria: CAT_5 },
  { nome: 'Kit dōTERRA Touch Emotional Aromatherapy®', tamanho: 'Caixa', preco: 751.25, pv: 100, categoria: CAT_5 },
  { nome: 'dōTERRA Forgive®', tamanho: '5ml', preco: 157.50, pv: 21, categoria: CAT_5 },
  { nome: 'dōTERRA Forgive® Touch Roll-On', tamanho: '10ml', preco: 101.25, pv: 13, categoria: CAT_5 },
  { nome: 'dōTERRA Motivate®', tamanho: '5ml', preco: 180.00, pv: 24, categoria: CAT_5 },
  { nome: 'dōTERRA Motivate® Touch Roll-On', tamanho: '10ml', preco: 112.50, pv: 15, categoria: CAT_5 },
  { nome: 'dōTERRA Passion®', tamanho: '5ml', preco: 209.25, pv: 28, categoria: CAT_5 },
  { nome: 'dōTERRA Passion® Touch Roll-On', tamanho: '10ml', preco: 185.00, pv: 27, categoria: CAT_5 },
  { nome: 'dōTERRA Peace®', tamanho: '5ml', preco: 232.50, pv: 31, categoria: CAT_5 },
  { nome: 'dōTERRA Peace® Touch Roll-On', tamanho: '10ml', preco: 150.00, pv: 20, categoria: CAT_5 },

  // ═══════ CATEGORIA 6 — CUIDADOS PESSOAIS ═══════
  { nome: 'Breathe Balm Stick', tamanho: '13,5g', preco: 111.25, pv: 14, categoria: CAT_6 },
  { nome: 'Citrus Bliss Loção para as Mãos', tamanho: '75ml', preco: 72.50, pv: 9, categoria: CAT_6 },
  { nome: 'Conditioner Hair Care Condicionador', tamanho: '500ml', preco: 159.00, pv: 18, categoria: CAT_6 },
  { nome: 'Conditioner Leave-in Condicionador Leave-in', tamanho: '237ml', preco: 148.75, pv: 15, categoria: CAT_6 },
  { nome: 'Correct-X® Gel Reparador', tamanho: '15ml', preco: 105.00, pv: 12, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Rub', tamanho: '120ml', preco: 222.75, pv: 33, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Rub Travel Pack', tamanho: '5 bisnagas', preco: 60.00, pv: 5, categoria: CAT_6 },
  { nome: 'dōTERRA Deep Blue® Stick + Copaiba', tamanho: '30g', preco: 139.00, pv: 23, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Esfoliante para o Corpo', tamanho: '226g', preco: 158.50, pv: 16, categoria: CAT_6 },
  { nome: 'Óleo de Coco Fracionado', tamanho: '115ml', preco: 106.25, pv: 11, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Loção para Mãos e Corpo', tamanho: '200ml', preco: 112.00, pv: 13, categoria: CAT_6 },
  { nome: 'HD Clear™ Roll-On', tamanho: '10ml', preco: 135.00, pv: 18, categoria: CAT_6 },
  { nome: 'Lavender Fields™ Body Splash', tamanho: '100ml', preco: 142.88, pv: 18, categoria: CAT_6 },
  { nome: 'On Guard® Creme Dental Natural', tamanho: '125g', preco: 70.00, pv: 5, categoria: CAT_6 },
  { nome: 'On Guard® Creme Dental Travel Pack', tamanho: '5 bisnagas', preco: 18.75, pv: 1, categoria: CAT_6 },
  { nome: 'Shampoo Protetor', tamanho: '500ml', preco: 145.00, pv: 18, categoria: CAT_6 },
  { nome: 'dōTERRA Pûre™ Femme Eau de Parfum', tamanho: '60ml', preco: 375.00, pv: 50, categoria: CAT_6 },
  { nome: 'dōTERRA Pûr™ Homme Eau de Parfum', tamanho: '60ml', preco: 375.00, pv: 50, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Sabonete Hidratante', tamanho: '250ml', preco: 98.00, pv: 10, categoria: CAT_6 },
  { nome: 'dōTERRA Spa Manteiga Hidratante Corporal', tamanho: '198g', preco: 168.00, pv: 14, categoria: CAT_6 },
  { nome: 'Salubelle™', tamanho: '10ml', preco: 543.75, pv: 68, categoria: CAT_6 },
  { nome: 'Verage Solução de Limpeza Facial', tamanho: '60ml', preco: 150.00, pv: 21, categoria: CAT_6 },
  { nome: 'Verage Hidratante Facial', tamanho: '30ml', preco: 217.50, pv: 27, categoria: CAT_6 },
  { nome: 'Verage Tônico Facial', tamanho: '50ml', preco: 217.00, pv: 22, categoria: CAT_6 },
  { nome: 'Verage Collection', tamanho: '', preco: 674.00, pv: 67, categoria: CAT_6 },
  { nome: 'Verage® Creme Hidratante', tamanho: '48g', preco: 227.50, pv: 32, categoria: CAT_6 },
  { nome: 'Yarrow|Pom', tamanho: '15ml', preco: 352.50, pv: 47, categoria: CAT_6 },
  { nome: 'Yarrow|Pom Ativo Botânico Duo', tamanho: '30ml', preco: 697.50, pv: 93, categoria: CAT_6 },

  // ═══════ CATEGORIA 7 — KITS E ACESSÓRIOS ═══════
  { nome: 'Kit Técnica dōTERRA AromaTouch® com Difusor', tamanho: 'Caixa', preco: 1225.00, pv: 115, categoria: CAT_7 },
  { nome: 'Kit Técnica dōTERRA AromaTouch®', tamanho: 'Caixa', preco: 780.00, pv: 104, categoria: CAT_7 },
  { nome: 'Blooming Trio Kit', tamanho: '', preco: 281.25, pv: 35, categoria: CAT_7 },
  { nome: 'Difusor de Parede Myst', tamanho: '', preco: 371.25, pv: 10, categoria: CAT_7 },
  { nome: 'dōTERRA Dawn® Umidificador Aromático', tamanho: '', preco: 598.00, pv: 15, categoria: CAT_7 },
  { nome: "dōTERRA Collector's Kit Box", tamanho: '', preco: 892.00, pv: 135, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Conforto', tamanho: '', preco: 285.00, pv: 48, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Equilíbrio', tamanho: '', preco: 298.00, pv: 46, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Inspire', tamanho: '', preco: 268.00, pv: 46, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Revitalize', tamanho: '', preco: 263.00, pv: 48, categoria: CAT_7 },
  { nome: 'dōTERRA Brasil Living Kit', tamanho: 'Caixa', preco: 720.00, pv: 120, categoria: CAT_7 },
  { nome: 'dōTERRA Construa seu Legado Kit', tamanho: '', preco: 1200.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA Culinária Essencial', tamanho: 'Caixa', preco: 668.75, pv: 66, categoria: CAT_7 },
  { nome: 'dōTERRA Culinária Essencial Sem Livro', tamanho: 'Caixa', preco: 537.50, pv: 55, categoria: CAT_7 },
  { nome: 'dōTERRA Essencial Para o Lar (Pebble)', tamanho: 'Caixa', preco: 1888.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA Essencial Para o Lar (Petal)', tamanho: 'Caixa', preco: 1888.00, pv: 200, categoria: CAT_7 },
  { nome: 'dōTERRA Kids Kit', tamanho: '', preco: 766.25, pv: 89, categoria: CAT_7 },
  { nome: 'Kit de Apresentação', tamanho: '', preco: 140.00, pv: 12, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Início Rápido', tamanho: '', preco: 600.00, pv: 100, categoria: CAT_7 },
  { nome: 'dōTERRA Kit Primeiros Cuidados', tamanho: '', preco: 1122.50, pv: 132, categoria: CAT_7 },
  { nome: 'dōTERRA Wooden Box', tamanho: '', preco: 79.00, pv: 0, categoria: CAT_7 },
  { nome: 'Gênesis Performance', tamanho: '', preco: 59.00, pv: 0, categoria: CAT_7 },
  { nome: 'Gênesis Beauty Fit', tamanho: '', preco: 750.00, pv: 100, categoria: CAT_7 },
  { nome: 'Kit com Difusor Pebble™', tamanho: '', preco: 173.75, pv: 11, categoria: CAT_7 },
  { nome: 'Livro Culinária Essencial', tamanho: '', preco: 112.50, pv: 10, categoria: CAT_7 },
  { nome: 'Petal 2.0 Kit', tamanho: '', preco: 498.75, pv: 75, categoria: CAT_7 },
]

// Normaliza texto (remove acentos) para busca
const normalizar = (s: string) =>
  s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')

const formatarBRL = (v: number) =>
  v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const chaveProduto = (p: Produto) => `${p.nome}__${p.tamanho}__${p.categoria}`

interface Props {
  lead?: any
}

export default function CalculadoraOleos({ lead }: Props) {
  const [busca, setBusca] = useState('')
  const [selecionados, setSelecionados] = useState<Produto[]>([])

  // Resultados filtrados em tempo real
  const resultados = useMemo(() => {
    const termo = normalizar(busca.trim())
    if (!termo) return []
    return PRODUTOS.filter(p => normalizar(p.nome).includes(termo)).slice(0, 30)
  }, [busca])

  const estaSelecionado = (p: Produto) =>
    selecionados.some(s => chaveProduto(s) === chaveProduto(p))

  const toggleProduto = (p: Produto) => {
    setSelecionados(prev => {
      const existe = prev.some(s => chaveProduto(s) === chaveProduto(p))
      if (existe) return prev.filter(s => chaveProduto(s) !== chaveProduto(p))
      return [...prev, p]
    })
  }

  const removerProduto = (p: Produto) => {
    setSelecionados(prev => prev.filter(s => chaveProduto(s) !== chaveProduto(p)))
  }

  // Cálculos automáticos
  const totalPV = selecionados.reduce((acc, p) => acc + p.pv, 0)
  const subtotal = selecionados.reduce((acc, p) => acc + p.preco, 0)
  // Frete: sempre R$32,00, independente do valor da compra
  const frete = selecionados.length > 0 ? 32 : 0
  const taxaAdesao = selecionados.length > 0 && totalPV < 100 ? 48 : 0
  const totalGeral = subtotal + frete + taxaAdesao

  // Parcelamento escalonado: < R$300 = sem; R$300–599,99 = 3x; >= R$600 = 3x e 6x
  const parcelamento = selecionados.length > 0
    ? totalGeral >= 600
      ? { em3x: totalGeral / 3, em6x: totalGeral / 6 }
      : totalGeral >= 300
        ? { em3x: totalGeral / 3, em6x: null }
        : null
    : null

  // Montar texto do orçamento
  const montarOrcamento = (): string => {
    const primeiroNome = (lead?.nome || '').split(' ')[0] || ''
    let texto = `*ORÇAMENTO dōTERRA*\n`
    if (primeiroNome) texto += `*${primeiroNome}*\n`
    texto += `\n`

    selecionados.forEach(p => {
      const tam = p.tamanho ? ` ${p.tamanho}` : ''
      texto += `- ${p.nome}${tam} → R$${formatarBRL(p.preco)}\n`
    })

    texto += `\n*Total de PV:* ${totalPV}`
    texto += `\n*Subtotal:* R$${formatarBRL(subtotal)}`
    texto += `\n*Frete:* R$32,00`
    if (totalPV >= 100) {
      texto += `\n*Taxa de adesão:* Isenta (compra acima de 100 PV)`
    } else {
      texto += `\n*Taxa de adesão:* R$48,00`
    }
    texto += `\n*Total:* R$${formatarBRL(totalGeral)}`

    if (parcelamento) {
      texto += `\n\n*Formas de pagamento:*`
      texto += `\n- À vista no Pix / boleto: R$${formatarBRL(totalGeral)}`
      texto += `\n- Parcelado em 3x de R$${formatarBRL(parcelamento.em3x)} no cartão`
      if (parcelamento.em6x !== null) {
        texto += `\n- Parcelado em 6x de R$${formatarBRL(parcelamento.em6x)} no cartão`
      }
    }

    return texto
  }

  const copiarOrcamento = async () => {
    if (selecionados.length === 0) {
      toast.error('Selecione pelo menos um óleo')
      return
    }
    try {
      await copiarTexto(montarOrcamento())
      toast.success('Orçamento copiado!')
    } catch {
      toast.error('Erro ao copiar')
    }
  }

  const abrirWhatsApp = () => {
    if (selecionados.length === 0) {
      toast.error('Selecione pelo menos um óleo')
      return
    }
    const numero = (lead?.whatsapp || '').replace(/\D/g, '')
    if (!numero) {
      toast.error('WhatsApp do cliente não disponível')
      return
    }
    const url = `https://wa.me/${numero}?text=${encodeURIComponent(montarOrcamento())}`
    window.open(url, '_blank')
  }

  return (
    <div className="space-y-5">
      {/* Campo de busca */}
      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5" style={{ color: '#B08968' }} />
        <input
          type="text"
          value={busca}
          onChange={e => setBusca(e.target.value)}
          placeholder="Digite o nome do óleo ou produto..."
          className="w-full pl-12 pr-4 py-3 rounded-xl border-2 focus:outline-none"
          style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF', color: '#2C2C2A' }}
        />
      </div>

      {/* Resultados da busca */}
      {busca.trim() && (
        <div
          className="rounded-xl border overflow-hidden"
          style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF' }}
        >
          {resultados.length === 0 ? (
            <div className="p-4 text-sm" style={{ color: '#5F5E5A' }}>
              Nenhum produto encontrado com esse nome.
            </div>
          ) : (
            <ul className="divide-y" style={{ borderColor: '#EDE0D4' }}>
              {resultados.map(p => {
                const marcado = estaSelecionado(p)
                return (
                  <li
                    key={chaveProduto(p)}
                    onClick={() => toggleProduto(p)}
                    className="flex items-center gap-3 p-3 cursor-pointer hover:bg-[#F8F4EF] transition-colors"
                  >
                    <input
                      type="checkbox"
                      checked={marcado}
                      onChange={() => toggleProduto(p)}
                      onClick={e => e.stopPropagation()}
                      className="w-5 h-5 accent-[#2D6A4F] cursor-pointer"
                    />
                    <div className="flex-1 min-w-0">
                      <div className="font-medium" style={{ color: '#2C2C2A' }}>
                        {p.nome}
                        {p.tamanho && (
                          <span className="ml-2 text-sm font-normal" style={{ color: '#5F5E5A' }}>
                            {p.tamanho}
                          </span>
                        )}
                      </div>
                      <div className="text-xs" style={{ color: '#B08968' }}>{p.categoria}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold" style={{ color: '#2D6A4F' }}>
                        R$ {formatarBRL(p.preco)}
                      </div>
                      <div className="text-xs" style={{ color: '#5F5E5A' }}>
                        {p.pv > 0 ? `${p.pv} PV` : 'sem PV'}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )}

      {/* Lista de selecionados */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <Calculator className="w-5 h-5" style={{ color: '#2D6A4F' }} />
          <h4 className="font-semibold" style={{ color: '#2D6A4F' }}>
            Produtos selecionados {selecionados.length > 0 && `(${selecionados.length})`}
          </h4>
        </div>

        {selecionados.length === 0 ? (
          <div
            className="p-4 rounded-xl text-sm text-center"
            style={{ backgroundColor: '#F8F4EF', color: '#5F5E5A', border: '1px dashed #EDE0D4' }}
          >
            Nenhum produto selecionado. Use a busca acima para adicionar produtos.
          </div>
        ) : (
          <ul
            className="divide-y rounded-xl border overflow-hidden"
            style={{ borderColor: '#EDE0D4', backgroundColor: '#FFFFFF' }}
          >
            {selecionados.map(p => (
              <li key={chaveProduto(p)} className="flex items-center gap-3 p-3">
                <div className="flex-1 min-w-0">
                  <div className="font-medium" style={{ color: '#2C2C2A' }}>
                    {p.nome}
                    {p.tamanho && (
                      <span className="ml-2 text-sm font-normal" style={{ color: '#5F5E5A' }}>
                        {p.tamanho}
                      </span>
                    )}
                  </div>
                  <div className="text-xs" style={{ color: '#5F5E5A' }}>
                    {p.pv > 0 ? `${p.pv} PV` : 'sem PV'}
                  </div>
                </div>
                <div className="font-semibold" style={{ color: '#2D6A4F' }}>
                  R$ {formatarBRL(p.preco)}
                </div>
                <button
                  onClick={() => removerProduto(p)}
                  className="p-1.5 rounded-full hover:bg-red-50 transition-colors"
                  title="Remover"
                >
                  <X className="w-4 h-4 text-red-500" />
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Totais */}
      {selecionados.length > 0 && (
        <div
          className="rounded-xl p-5 space-y-2"
          style={{ backgroundColor: '#D8F3DC', border: '1px solid #52B788' }}
        >
          <div className="flex justify-between items-center">
            <span style={{ color: '#2C2C2A' }}>Total de PV</span>
            <span className="font-semibold" style={{ color: '#2D6A4F' }}>{totalPV}</span>
          </div>
          <div className="flex justify-between items-center">
            <span style={{ color: '#2C2C2A' }}>Subtotal dos produtos</span>
            <span className="font-semibold" style={{ color: '#2D6A4F' }}>R$ {formatarBRL(subtotal)}</span>
          </div>
          <div className="flex justify-between items-center">
            <span style={{ color: '#2C2C2A' }}>Frete</span>
            <span className="font-semibold" style={{ color: '#2D6A4F' }}>R$ 32,00</span>
          </div>
          <div className="flex justify-between items-center">
            <span style={{ color: '#2C2C2A' }}>Taxa de adesão</span>
            <span className="font-semibold" style={{ color: '#2D6A4F' }}>
              {totalPV >= 100 ? 'Isenta' : 'R$ 48,00'}
            </span>
          </div>
          <div className="border-t pt-2 mt-2" style={{ borderColor: '#52B788' }}>
            <div className="flex justify-between items-center">
              <span className="text-lg font-semibold" style={{ color: '#2C2C2A' }}>Total geral</span>
              <span className="text-xl font-bold" style={{ color: '#2D6A4F' }}>
                R$ {formatarBRL(totalGeral)}
              </span>
            </div>
          </div>

          {parcelamento && (
            <div
              className="mt-3 p-3 rounded-lg text-sm space-y-1"
              style={{ backgroundColor: '#FFFFFF', color: '#2D6A4F', border: '1px solid #A8DFC4' }}
            >
              <p className="font-semibold" style={{ color: '#2C2C2A' }}>Formas de pagamento:</p>
              <p>• À vista no Pix / boleto: <strong>R$ {formatarBRL(totalGeral)}</strong></p>
              <p>• Parcelado em <strong>3x de R$ {formatarBRL(parcelamento.em3x)}</strong> no cartão</p>
              {parcelamento.em6x !== null && (
                <p>• Parcelado em <strong>6x de R$ {formatarBRL(parcelamento.em6x)}</strong> no cartão</p>
              )}
            </div>
          )}
        </div>
      )}

      {/* Botões de ação */}
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          onClick={copiarOrcamento}
          disabled={selecionados.length === 0}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-full font-medium transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: '#2D6A4F', color: '#FFFFFF' }}
        >
          <Copy className="w-4 h-4" />
          Copiar orçamento
        </button>
        <button
          onClick={abrirWhatsApp}
          disabled={selecionados.length === 0}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-full font-medium transition-all text-white disabled:opacity-50 disabled:cursor-not-allowed"
          style={{ backgroundColor: '#25D366' }}
        >
          <MessageCircle className="w-4 h-4" />
          Abrir no WhatsApp
        </button>
      </div>
    </div>
  )
}
